import AutocompleteInput from './AutocompleteInput.vue';

export default AutocompleteInput;
